import { UsersImport } from './Imports'
const { RoutesMap, Profile, CustomerList, CustomerDetails, AddCustomer, UpdateCustomer, MemberList, AgronomyList, SupervisorList, StaffList } = UsersImport

const UsersRoute = () => {
    return [

        {
            path: RoutesMap.PROFILE.path,
            element: <Profile />
        },


        {
            path: RoutesMap.CUSTOMER_LIST.path,
            element: <CustomerList />
        },
        {
            path: RoutesMap.CUSTOMER_DETAILS.path,
            element: <CustomerDetails />
        },
        {
            path: RoutesMap.ADD_CUSTOMER.path,
            element: <AddCustomer />
        },
        {
            path: RoutesMap.UPDATE_CUSTOMER.path,
            element: <UpdateCustomer />
        },


        {
            path: RoutesMap.MEMBER_LIST.path,
            element: <MemberList />
        },


        {
            path: RoutesMap.AGRONOMY_LIST.path,
            element: <AgronomyList />
        },


        {
            path: RoutesMap.SUPERVISOR_LIST.path,
            element: <SupervisorList />
        },


        {
            path: RoutesMap.STAFF_LIST.path,
            element: <StaffList />
        },

    ]
}

export default UsersRoute;